import styled from 'styled-components'
import { mildGray } from '../../styles/variables.js'

const Content = styled.div`
  display: flex;
  flex-direction: row:
`

const List = styled.div`
  margin: 5px;
  max-width: 280px;
`
const Locale = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0;
`

const DeleteLink = styled.div`
  margin-left: 10px;
  margin-top: 15px;
  cursor: pointer;
  color: ${mildGray};
  transition: all .1s ease-in-out;
  font-size: 22px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`

export default {
  List,
  Locale,
  DeleteLink,
  Content,
}
